import { RouteParameters } from "./route-parameters";

const ENGINE_TRENDING_ROUTING = {
  CREATE: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/engine-trending/create`,
  HELP: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/engine-trending/help`,
  ROOT: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/engine-trending`,
  VIEW: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/engine-trending/view`,
} as const;

const ENGINE_TRENDING_ROUTES = [
  ENGINE_TRENDING_ROUTING.ROOT,
  ENGINE_TRENDING_ROUTING.VIEW,
  ENGINE_TRENDING_ROUTING.CREATE,
  ENGINE_TRENDING_ROUTING.HELP,
] as const;

export { ENGINE_TRENDING_ROUTES, ENGINE_TRENDING_ROUTING };
